import { REHYDRATE } from "redux-persist";
import { actionRehydrate } from "@utils";
import {
  STRUCTURE_TYPES_FETCH,
  STRUCTURE_TYPES_FETCH_MORE,
  STRUCTURE_TYPES_FETCH_PENDING,
  STRUCTURE_TYPES_REJECTED
} from "../../constants";

const initialState = {
  data: {
    results: [],
  },
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return actionRehydrate(state, action.payload, "structures");
    case STRUCTURE_TYPES_FETCH_PENDING:
      return {
        ...state,
        isFetching: true,
      };
    case STRUCTURE_TYPES_REJECTED:
      return {
        ...state,
        isFetching: false,
      };
    case STRUCTURE_TYPES_FETCH:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data.data,
      };
    case STRUCTURE_TYPES_FETCH_MORE:
      return {
        ...state,
        isFetching : false,
        data : {
          ...action.payload.data.data,
          results : _.merge(action.payload.data.data.results,state.data.results)
        }
      };
    default:
      return state;
  }
}
